/* @flow */
import { combineReducers } from 'redux-immutable';
import type { Action } from 'trustar/utils/redux-types.js';

/**
 * NOTE: Only default export should be used. It should be the root reducer.
 * Other exports ore only to allow importing into our tests.
 */

import {
  REPROCESS_REPORTS,
  REPROCESS_REPORTS_SUCCESS,
  REPROCESS_REPORTS_FAILURE,
  SET_REINDEX_OPTIONS,
} from './action-types.js';
import { Status, ReindexOptions } from './types.js';
import type { StatusRecord, ReindexOptionsRecord } from './types.js';

export const reprocessReports = (state: StatusRecord = Status(), action: Action<*>) => {
  const { type } = action;

  switch (type) {
  case REPROCESS_REPORTS:
    return state.merge({ loading: true });
  case REPROCESS_REPORTS_SUCCESS:
    return state.merge({ loading: false, complete: true });
  case REPROCESS_REPORTS_FAILURE:
    return state.merge({ loading: false });
  default:
    return state;
  }
};

export const reindexOptions = (state: ReindexOptionsRecord = ReindexOptions(), action: Action<*>) => {
  const { type, payload } = action;

  switch (type) {
  case SET_REINDEX_OPTIONS:
    return state.merge(payload);
  default:
    return state;
  }
};

export default combineReducers({
  reprocessReports,
  reindexOptions,
});



// WEBPACK FOOTER //
// ./src/app/modules/devtasks/stores.js